const industryCouncil = r => require.ensure([], () => r(require('@/page/industryCouncil/industryCouncil')), 'industryCouncil');
const industryCouncilMge = r => require.ensure([], () => r(require('@/page/industryCouncil/industryCouncilMge/industryCouncilMge')), 'industryCouncilMge');
const industryCouncilRecord = r => require.ensure([], () => r(require('@/page/industryCouncil/industryCouncilRecord/industryCouncilRecord')), 'industryCouncilRecord');
const industryCouncilUpdate = r => require.ensure([], () => r(require('@/page/industryCouncil/industryCouncilUpdate/industryCouncilUpdate')), 'industryCouncilUpdate');


const industryCouncilRouter =
{
    path: '',
    name: '业委会自管',
    meta:{icon:'inspectionAndEvaMge',right: [],
        isShowMenu:true,
        keepAlive:true,
    },
    component: industryCouncil,
    children: [
        { path: '/industryCouncilMge', component: industryCouncilMge, name: '业委会自管申请',
            meta: { right: ['业主委员会自管业务申请'],
                isShowMenu: true,
                keepAlive:true,
            }, },
        { path: '/industryCouncilRecord', component: industryCouncilRecord, name: '业委会自管申请备案',
            meta: { right: ['业主委员会自管业务申请'],
                isShowMenu: true,
                keepAlive:true,
            }, },
        { path: '/industryCouncilUpdate', component: industryCouncilUpdate, name: '业委会换届业务',
            meta: { right: ['业主委员会换届业务申请'],
                isShowMenu: true,
                keepAlive:true,
            }, },
    ]
};
export default industryCouncilRouter;